import { RefreshCw } from 'lucide-react'
import { Switch } from './switch'
import { cn } from '../utils/cn'

interface ToggleSwitchProps {
  checked: boolean
  onChange: (e?: React.MouseEvent) => void
  size?: 'sm' | 'md' | 'lg'
  variant?: 'standard' | 'bordered'
  saving?: boolean
  disabled?: boolean
}

const SPINNER_SIZE: Record<'sm' | 'md' | 'lg', number> = { sm: 10, md: 10, lg: 12 }

export default function ToggleSwitch({
  checked,
  onChange,
  size = 'md',
  variant = 'standard',
  saving = false,
  disabled = false,
}: ToggleSwitchProps) {
  return (
    <div className="relative inline-flex">
      <Switch
        size={size}
        checked={checked}
        disabled={disabled}
        onClick={(e) => onChange(e)}
        onCheckedChange={() => {
          /* handled via onClick to preserve the existing event signature */
        }}
        className={cn(
          variant === 'bordered' &&
            'data-[state=unchecked]:bg-charcoal data-[state=unchecked]:border data-[state=unchecked]:border-white/10 data-[state=checked]:bg-gold/30 data-[state=checked]:border data-[state=checked]:border-gold/40',
          variant === 'bordered' &&
            '[&>span]:data-[state=checked]:bg-gold [&>span]:data-[state=unchecked]:bg-pearl/40',
        )}
      />
      {saving && (
        <RefreshCw
          className="pointer-events-none absolute right-1 top-1/2 -translate-y-1/2 animate-spin text-midnight"
          size={SPINNER_SIZE[size]}
        />
      )}
    </div>
  )
}
